import { FC, Suspense, useState } from 'react';
import ClassesRostersBody from '../components/ClassesRoster/ClassesRostersBody';
import ClassesRosterDetail from '../components/ClassesRoster/ClassesRosterDetail';
import { MainFallback } from '../components/Fallback/MainFallBack';
import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isUserAdmin } from '../businessLogicService/isUserAdmin';
import { useSideNavActive } from '../components/LayoutWrapper/SideNavLayoutContext';
import { usePageTabs } from '../components/LayoutWrapper/PageTabsContext';
import Students from './Students';
import Teachers from './Teachers';

const ClassesRosters: FC = () => {
  const navigate = useNavigate();
  const sideNavActive = useSideNavActive();
  const [searchParams, setSearchParams] = useSearchParams();
  const userRedux = useAppSelector(selectUser);
  const classId = searchParams.get('classId');
  const showTabs = sideNavActive && isUserAdmin(userRedux) && !classId;
  const activeTab = usePageTabs(
    showTabs ? [{ label: 'All Classes' }, { label: 'Students' }, { label: 'Teachers & Admins' }] : [],
  );
  const [className, setClassName] = useState('');

  const pageTitleCenterContent = () => {
    return <h1>Classes & Rosters</h1>;
  };

  const breadcrumbItems = [
    { label: 'Set Up', command: () => navigate('/setting-up') },
    // On the detail view, this crumb returns to the grid; on the grid it's the current page.
    { label: 'Classes & Rosters', command: classId ? () => setSearchParams({}) : undefined },
    ...(classId && className ? [{ label: className }] : []),
  ];

  const home = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };
  const isAdmin = isUserAdmin(userRedux);

  return (
    <>
      <div className="nc_page-inner nc_page-side-margin flex-grow-1 overflow-x-hidden pb-8 nc_classes-page">
        <div className="grid">
          {!sideNavActive && (
            <div className="col-10 col-offset-1 lg:col-12 lg:col-offset-0 flex flex-column nc_content-frame">
              <Toolbar role="presentation" center={pageTitleCenterContent} className="nc_page-header" />
              <BreadCrumb model={breadcrumbItems} home={home} />
            </div>
          )}
          {showTabs && !classId && (
            <div className="col-12 nc_classes-people-panel">
              <Suspense fallback={<MainFallback />}>
                {activeTab === 0 && <ClassesRostersBody isAdmin={isAdmin} />}
                {activeTab === 1 && <Students />}
                {activeTab === 2 && <Teachers />}
              </Suspense>
            </div>
          )}

          {!(showTabs && !classId) && (
            <Suspense fallback={<MainFallback />}>
              {classId ? (
                <ClassesRosterDetail
                  classId={classId}
                  onSelectClass={id => setSearchParams({ classId: id })}
                  onClassLoaded={setClassName}
                />
              ) : (
                <ClassesRostersBody isAdmin={isAdmin} />
              )}
            </Suspense>
          )}
        </div>
      </div>
    </>
  );
};

export default ClassesRosters;
